import type { UpdateCheck } from '../pwa/register';

/** How long "You have the latest version" and a failed check stay on screen before the link comes back alone. */
export const UPDATE_STATUS_MS = 4000;

/** A found update keeps its message and action until it is used; every other answer clears itself. */
export const clearsItself = (r: UpdateCheck | 'checking' | undefined): boolean => r === 'latest' || r === 'offline' || r === 'unavailable';

/**
 * After a check ends with `result`: clears the message after `ms` (only if it is still that message, so a newer check isn't
 * cleared early). Returns the timer, or undefined when the result stays (an update was found).
 */
export function clearLater(result: UpdateCheck, get: () => UpdateCheck | 'checking' | undefined, clear: () => void, ms = UPDATE_STATUS_MS, timer: typeof setTimeout = setTimeout): ReturnType<typeof setTimeout> | undefined {
  if (!clearsItself(result)) return undefined;
  return timer(() => {
    if (get() === result) clear();
  }, ms);
}
